<template>
  <div
    class="page"
    v-loading.fullscreen.lock="fullscreenLoading"
    :element-loading-text="fullscreenLoadingText"
    element-loading-background="rgba(255, 255, 255, 0.72)"
  >
    <div class="wrap">
      <el-card class="top" shadow="always">
        <div>
          <div class="title-row">
            <svg
              t="1776082086858"
              class="back-icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="3195"
              width="200"
              height="200"
              role="button"
              aria-label="返回列表"
              tabindex="0"
              @click="back"
              @keydown.enter.prevent="back"
              @keydown.space.prevent="back"
            >
              <path
                d="M210.4 511.1 641.3 80.2c22.8-22.8 59.8-22.8 82.6 0 22.8 22.8 22.8 59.8 0 82.6L375.7 511.1l348.3 348.3c22.8 22.8 22.8 59.8 0 82.6-22.8 22.8-59.8 22.8-82.6 0L210.4 511.1 210.4 511.1zM210.4 511.1"
                p-id="3196"
              ></path>
            </svg>
            <div class="title">{{ titleMain }}</div>
          </div>
        </div>
      </el-card>

      <div style="height: 12px" />

      <div class="grid">
        <el-card class="card" shadow="always" style="height: 540px;">
          <div slot="header" class="cardH">
            <strong>面试录像回放</strong>
            <el-button size="mini" @click="download">下载录像</el-button>
          </div>

          <div ref="videoShell" class="videoWrap">
            <video
              :key="videoSrc"
              ref="player"
              controls
              playsinline
              class="videoEl"
              @timeupdate="onVideoTimeUpdate"
              @loadedmetadata="onVideoLoaded"
              @ratechange="onVideoRateChange"
              @error="onVideoError"
            >
              <source :src="videoSrc" type="video/mp4" />
            </video>
            <div class="videoToolbar">
              <div v-if="segmentEndTime != null" class="segmentHint">
                片段播放中：{{ formatClock(segmentStartTime) }} — {{ formatClock(segmentEndTime) }}（到点自动暂停）
              </div>
            </div>

            <!-- 右下角自定义倍速/全屏控件已移除，直接使用 video 原生 controls -->
          </div>

          <div class="videoUnderHint" style="margin-top: 30px;">
            <div class="overlayHint">在异常时间轴列表，点击查看片段，从该异常点前5秒起播，播满10秒时间片段后自动暂停。</div>
            <div class="riskMeta" style="margin-top: 15px;">
              <el-tag size="mini" type="success" effect="light">风险等级：{{ riskLevel || "—" }}</el-tag>
              <el-tag size="mini" effect="light">风险总分：{{ riskScore || "—" }} </el-tag>
              <el-tag size="mini" effect="plain">异常行为总数：{{ abnormalCount }} 次</el-tag>
            </div>
          </div>

          <!-- <div class="metrics">
            <el-tag v-if="frameMeta.total_frames != null" size="mini" effect="plain">总帧：{{ frameMeta.total_frames }}</el-tag>
            <el-tag v-if="frameMeta.normal_count != null" size="mini" effect="plain">正常：{{ frameMeta.normal_count }}</el-tag>
          </div> -->
        </el-card>

        <el-card class="card timelineCard" shadow="always" style="height: 540px;">
          <div slot="header" class="cardH" style="height: 49px;">
            <strong>AI 检测意见 & 异常时间轴</strong>
          </div>

          <div class="twoCol">
            <div class="box">
              <div class="boxTitle">AI 检测意见</div>
              <div class="boxTextWrap loading-gray" v-loading="frameReportLoading">
                <div class="boxText">{{ aiDetectionSummary || "—" }}</div>
              </div>
            </div>
            <!-- <div class="box">
              <div class="boxTitle">系统建议</div>
              <div class="boxTextWrap loading-gray" v-loading="frameReportLoading">
                <div class="boxText" v-html="systemSuggestionHtml"></div>
              </div>
            </div> -->
          </div>

          <div class="timelineSection" :style="timelineBlockStyle">
            <div class="tlTitle">异常时间轴</div>
            <div
              ref="timelineBlockScroller"
              class="timelineBlockScroller loading-gray"
              v-loading="frameListLoading || tlPanelThumbLoading"
              :element-loading-text="timelineScrollerLoadingText"
              @pointerdown.self="onTimelineScrollbarPointerDown"
              @scroll.passive="onTimelineScroll"
            >
              <div v-if="!timeline.length && !frameListLoading" class="tlEmpty">暂无异常帧数据</div>
              <div
                v-else
                class="virtualTlPhantom"
                :style="{ height: tlPhantomHeightPx + 'px', position: 'relative' }"
              >
                <div
                  class="virtualTlWindow"
                  :style="{
                    transform: 'translateY(' + tlTranslateYPx + 'px)',
                    position: 'absolute',
                    left: '0',
                    right: '0',
                    top: '0',
                  }"
                >
                  <div
                    v-for="it in visibleTimeline"
                    :key="it.id"
                    class="virtualTlRowSlot"
                    :style="{ height: tlSlotPx + 'px', boxSizing: 'border-box' }"
                  >
                    <div class="tlItem" :style="{ height: tlItemPx + 'px', boxSizing: 'border-box' }">
                      <div class="tlLeft">
                        <div v-if="tlThumbSlotVisible(it)" class="tlThumbSlot">
                          <div v-show="tlThumbPendingSkeleton(it)" class="tlThumbPh">
                            <i class="el-icon-loading tlThumbPhIcon" aria-hidden="true"></i>
                          </div>
                          <img
                            v-if="timelineThumbSrc(it)"
                            class="tlThumb"
                            :class="{ tlThumbVisible: it._thumbImgLoaded }"
                            :src="timelineThumbSrc(it)"
                            loading="lazy"
                            decoding="async"
                            alt=""
                            @load="onTlThumbImgDone(it)"
                            @error="onTlThumbImgDone(it)"
                          />
                        </div>
                        <el-tag size="mini" :type="it.type === 'warn' ? 'warning' : 'danger'" effect="light">{{ it.t }}</el-tag>
                        <div class="tlText">
                          <div class="tlK">{{ it.label || it.behavior || "—" }}</div>
                          <el-tooltip
                            :disabled="!it._descOverflow || !timelineDescText(it)"
                            :content="timelineDescText(it)"
                            placement="top"
                          >
                            <div class="tlD" @mouseenter="onTlDescMouseEnter(it, $event)">
                              {{ timelineDescText(it) }}
                            </div>
                          </el-tooltip>
                        </div>
                      </div>
                      <el-button size="mini" @click="playSegment(it)">查看片段</el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </div>

      <div style="height: 12px" />

      <el-card class="card" shadow="always">
        <div slot="header" class="cardH">
          <strong>复核结论</strong>
        </div>

        <el-radio-group v-model="decision" :disabled="isViewMode">
          <el-radio :label="1">AI 判断正确，确认正常</el-radio>
          <el-radio :label="2">AI 误判，标记为正常</el-radio>
          <el-radio :label="3">确认存在作弊行为</el-radio>
        </el-radio-group>

        <div style="height: 20px" />
        <el-input
          type="textarea"
          v-model.trim="remark"
          :disabled="isViewMode"
          :rows="4"
          maxlength="300"
          show-word-limit
          :placeholder="isViewMode ? '' : '请输入复核结论'"
        />

        <div class="btnRow">
          <el-button :disabled="submittingRemarks" @click="back">返回</el-button>
          <el-button
            v-if="!isViewMode"
            type="primary"
            :loading="submittingRemarks"
            :disabled="submittingRemarks"
            @click="submit"
          >
            提交
          </el-button>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import morePersonImg from "@/assets/morePerson.png";
import {
  getFrameList,
  getCommonFileLink,
  getInterviewVideoAsset,
  getFrameReport,
  submitRecordingRemarks,
} from "@/api/modules/interview/interview";
import { get as commonGet } from "@/api/common/request";

// 片段播放：默认前 5 秒 + 后 5 秒（总计 10 秒）
const SEGMENT_DURATION_SEC = 10;

/** 异常时间轴虚拟列表：每条卡片内容高度（与 .tlItem + 原 padding 一致） */
const TL_ITEM_PX = 60;
/** 卡片之间的间隙（与原 .timeline { gap: 8px } 一致） */
const TL_GAP_PX = 8;
/** 每条在滚动条里占用的总高度 = 卡片 + 间隙，虚拟滚动用此值计算 */
const TL_SLOT_PX = TL_ITEM_PX + TL_GAP_PX;
/** 可视区上下多渲染的行数，减少快速滚动白屏 */
const TL_OVERSCAN = 10;
/** 缩略图签名请求合并防抖（毫秒） */
const TL_THUMB_SIGN_DEBOUNCE_MS = 80;

// behavior 异常类型对照表：只用后端返回的英文枚举名（兼容 camelCase）
// 例如：LeaveSeat -> LEAVE_SEAT
const BEHAVIOR_SNAKE_TO_LABEL = {
  HEAD_DOWN: "低头/抬头",
  TURN_HEAD: "转头",
  LEAVE_SEAT: "离开画面",
  MULTI_PEOPLE: "多人入境",
  IDENTITY_VERIFY: "身份核验",
  CAMERA_OFF: "关闭摄像头（黑屏）",
  MULTI_VOICEPRINT: "多声纹识别",
  SYNTHESIZED_VOICE: "语音合成检测",
  MICROPHONE_OFF: "关闭麦克风",
  SWITCH_TAB: "切屏",
  MINIMIZE_WINDOW: "最小化窗口",
  COPY_PASTE: "复制粘贴",
  MOUSE_CHECK: "鼠标检查",
  MICROPHONE_CHECK: "麦克风检查",
  MULTI_MONITOR: "分屏检查",
  BROWSER_SCREEN_CHECK: "浏览器屏幕大小检查",
  PAGE_BLUR: "页面失焦",
};

function pickSignedUrl(res) {
  const raw = res && (res.data !== undefined ? res.data : res);
  if (typeof raw === "string") return raw;
  if (raw && typeof raw === "object") {
    return raw.url || raw.link || raw.fileUrl || raw.signedUrl || raw.href || raw.response || "";
  }
  return "";
}

function pickCosUrl(res) {
  const raw = res && (res.data !== undefined ? res.data : res);
  if (!raw || typeof raw !== "object") return "";
  return raw.cos_url || raw.cosUrl || "";
}

function extractFileNameFromUrl(url) {
  const s = String(url || "").trim();
  if (!s) return "";
  try {
    const u = new URL(s);
    const pathname = u.pathname || "";
    // 去掉开头 /
    return pathname.startsWith("/") ? pathname.slice(1) : pathname;
  } catch (_) {
    // 非标准 URL：退回最简单的截取
    return s.split("?")[0].split("#")[0].replace(/^\/+/, "");
  }
}

/** 等待单张缩略图 <img> 解码（含加载失败，避免永远挂起） */
function waitForImageEl(img) {
  if (!img || !(img instanceof HTMLImageElement)) return Promise.resolve();
  if (img.complete) return Promise.resolve();
  return new Promise((resolve) => {
    const done = () => resolve();
    img.addEventListener("load", done, { once: true });
    img.addEventListener("error", done, { once: true });
  });
}

export default {
  name: "InterviewReview",
  data() {
    return {
      /** 复核结论：1 AI 判断正确；2 AI 误判；3 存在作弊 */
      decision: 1,
      remark: "",
      submittingRemarks: false,
      videoSrc: "",
      videoFileName: "",
      videoCosUrl: "",
      timeline: [],
      frameListLoading: false,
      frameMeta: {},
      abnormalCount: 0,
      timelineBlockHeight: null,
      aiDetectionSummary: "",
      systemSuggestion: "",
      /** 进入页面即为 true，检测意见接口结束（成功/失败）后置 false */
      frameReportLoading: true,
      riskLevel: "",
      riskScore: "",
      /** 异常点时刻（秒），从前 5 秒处起播 */
      segmentLeadSec: 5,
      segmentStartTime: null,
      segmentEndTime: null,
      playbackRate: 1,
      playbackRates: [0.5, 0.75, 1, 1.25, 1.5, 2],
      fullscreenLoading: false,
      fullscreenLoadingText: "加载中...",
      /** 异常时间轴虚拟滚动 */
      tlScrollTop: 0,
      tlViewportH: 320,
      tlItemPx: TL_ITEM_PX,
      tlSlotPx: TL_SLOT_PX,
      _tlThumbSignTimer: null,
      _tlScrollRaf: null,
      /** 拖动滚动条松手后，可视区缩略图签名/图片未就绪时遮罩（与 frameListLoading 合并到 v-loading） */
      tlPanelThumbLoading: false,
      /** 仅在滚动容器自身按下（含滚动条轨道）时置位，避免点在列表行/按钮上误触发 */
      _tlPointerDownOnScrollbar: false,
      _tlDidScrollWhilePointerDown: false,
      _tlFinishingVisibleThumbs: false,
    };
  },
  computed: {
    systemSuggestionHtml() {
      return this.renderBoldMarkdownToHtml(this.systemSuggestion || "");
    },
    interviewId() {
      const q = this.$route.query.interviewId || this.$route.query.id;
      const n = q != null && q !== "" ? Number(q) : NaN;
      return Number.isFinite(n) ? n : NaN;
    },
    interviewIdDisplay() {
      return Number.isFinite(this.interviewId) ? this.interviewId : "—";
    },
    timelineBlockStyle() {
      if (!Number.isFinite(this.timelineBlockHeight)) return {};
      return { height: `${this.timelineBlockHeight}px` };
    },
    name() {
      return this.$route.query.candidate_name || this.$route.query.name || "";
    },
    role() {
      return this.$route.query.position || this.$route.query.role || "";
    },
    isViewMode() {
      return String(this.$route.query.mode || "").toLowerCase() === "view";
    },
    titleMain() {
      const modeLabel = this.isViewMode ? "查看复核" : "面试复核";
      return `${modeLabel}：${this.name} - ${this.role}`;
    },
    tlPhantomHeightPx() {
      return Math.max(0, this.timeline.length) * this.tlSlotPx;
    },
    tlStartIndex() {
      const slot = this.tlSlotPx;
      return Math.max(0, Math.floor(this.tlScrollTop / slot) - TL_OVERSCAN);
    },
    tlEndIndex() {
      const slot = this.tlSlotPx;
      const vh = this.tlViewportH > 0 ? this.tlViewportH : 320;
      const visibleCount = Math.ceil(vh / slot) + 2;
      const start = Math.floor(this.tlScrollTop / slot);
      return Math.min(this.timeline.length, start + visibleCount + TL_OVERSCAN);
    },
    visibleTimeline() {
      return this.timeline.slice(this.tlStartIndex, this.tlEndIndex);
    },
    tlTranslateYPx() {
      return this.tlStartIndex * this.tlSlotPx;
    },
    /** 异常时间轴区域 loading 文案 */
    timelineScrollerLoadingText() {
      if (this.frameListLoading) return "加载中…";
      if (this.tlPanelThumbLoading) return "缩略图加载中…";
      return "";
    },
  },
  mounted() {
    this.initReviewFormFromQuery();
    this.loadVideoAndFrames();
    // 右侧时间轴滚动区域高度跟随左侧视频区域
    this.syncTimelineHeight();
    window.addEventListener("resize", this.syncTimelineHeight);
    window.addEventListener("resize", this.onWindowResizeTl);
    this.$nextTick(() => {
      this.updateTlViewport();
      this.scheduleEnsureTimelineThumbs();
    });
    window.addEventListener("pointerup", this.onTimelineGlobalPointerUp, true);
  },
  beforeDestroy() {
    window.removeEventListener("pointerup", this.onTimelineGlobalPointerUp, true);
    window.removeEventListener("resize", this.syncTimelineHeight);
    window.removeEventListener("resize", this.onWindowResizeTl);
    if (this._tlThumbSignTimer) {
      clearTimeout(this._tlThumbSignTimer);
      this._tlThumbSignTimer = null;
    }
    if (this._tlScrollRaf) {
      cancelAnimationFrame(this._tlScrollRaf);
      this._tlScrollRaf = null;
    }
  },
  methods: {
    initReviewFormFromQuery() {
      const conclusionRaw = this.$route.query.review_conclusion;
      const conclusion = Number(conclusionRaw);
      if ([1, 2, 3].includes(conclusion)) {
        this.decision = conclusion;
      }

      const remarksRaw = this.$route.query.review_remarks;
      if (remarksRaw != null) {
        this.remark = String(remarksRaw);
      }
    },
    behaviorToLabel(behavior) {
      // 后端返回英文：可能是 "LeaveSeat" 或 "LEAVE_SEAT"
      const raw = String(behavior || "").trim();
      if (!raw) return "—";

      const upper = raw.toUpperCase();
      if (BEHAVIOR_SNAKE_TO_LABEL[upper]) return BEHAVIOR_SNAKE_TO_LABEL[upper];

      // camelCase -> upper_snake_case
      const snake = raw
        .replace(/([a-z0-9])([A-Z])/g, "$1_$2")
        .replace(/([A-Z]+)([A-Z][a-z0-9]+)/g, "$1_$2")
        .toUpperCase();
      return BEHAVIOR_SNAKE_TO_LABEL[snake] || raw;
    },
    behaviorToSnake(behavior) {
      const raw = String(behavior || "").trim();
      if (!raw) return "";
      const upper = raw.toUpperCase();
      if (BEHAVIOR_SNAKE_TO_LABEL[upper]) return upper;
      return raw
        .replace(/([a-z0-9])([A-Z])/g, "$1_$2")
        .replace(/([A-Z]+)([A-Z][a-z0-9]+)/g, "$1_$2")
        .toUpperCase();
    },
    isMultiVoiceprintItem(it) {
      if (!it) return false;
      if (it.label === BEHAVIOR_SNAKE_TO_LABEL.MULTI_VOICEPRINT) return true;
      return this.behaviorToSnake(it.behavior) === "MULTI_VOICEPRINT";
    },
    timelineThumbSrc(it) {
      if (this.isMultiVoiceprintItem(it)) return morePersonImg;
      if (!it) return "";
      if (it.thumbSignedUrl) return it.thumbSignedUrl;
      const raw = String(it.cos_key || "").trim();
      if (/^https?:\/\//i.test(raw)) return raw;
      return "";
    },
    /** 是否显示左侧缩略图占位区（含等待签名 URL 阶段） */
    tlThumbSlotVisible(it) {
      if (!it) return false;
      if (this.isMultiVoiceprintItem(it)) return true;
      if (this.timelineThumbSrc(it)) return true;
      const raw = String(it.cos_key || "").trim();
      return !!raw;
    },
    onTlThumbImgDone(it) {
      if (!it) return;
      this.$set(it, "_thumbImgLoaded", true);
    },
    timelineDescText(it) {
      return it && it.label ? `疑似存在${it.label}，请结合录像复核。` : "";
    },
    onTlDescMouseEnter(it, e) {
      if (!it || !e || !e.currentTarget) return;
      const text = this.timelineDescText(it);
      if (!text) {
        this.$set(it, "_descOverflow", false);
        return;
      }
      const el = e.currentTarget;
      const isOverflow = el.scrollWidth > el.clientWidth;
      this.$set(it, "_descOverflow", isOverflow);
    },
    /** 缩略图区域是否显示转圈：有地址则等 decode；无地址则仅在等待签名时转圈 */
    tlThumbPendingSkeleton(it) {
      if (!this.tlThumbSlotVisible(it)) return false;
      const src = this.timelineThumbSrc(it);
      if (src) return !it._thumbImgLoaded;
      if (it._thumbSignEmpty) return false;
      const raw = String(it.cos_key || "").trim();
      return !!raw;
    },
    async loadVideoAndFrames() {
      if (!Number.isFinite(this.interviewId)) {
        this.$message.error("缺少面试复核 ID，无法加载数据。");
        return;
      }
      await Promise.all([
        this.resolveVideoSrc().catch(() => {}),
        this.loadFrameReport().catch(() => {}),
        this.loadFrameList().catch(() => {}),
      ]);
    },
    async resolveVideoSrc() {
      // try {
        const assetRes = await getInterviewVideoAsset(this.interviewId);
        const cosUrl = String(pickCosUrl(assetRes) || "").trim();

        // 后端返回：data.cos_url 为对象 key，用它去拿签名地址
        if (cosUrl) {
          this.videoCosUrl = cosUrl;
          // 直接把 cos_url 当作对象 key 保存（用于后续下载/兜底）
          this.videoFileName = cosUrl;

          const res = await getCommonFileLink({ fileName: cosUrl });
          const url = pickSignedUrl(res);
          if (url) {
            this.videoSrc = url;
            this.$nextTick(() => {
              const v = this.$refs.player;
              if (v && typeof v.load === "function") v.load();
            });
            return;
          }
        }

        // 没拿到 cos_url 或签名失败：保持 videoSrc 为空
      // } catch (e) {
      //   this.$message.error("获取录像地址失败。");
      // }
    },
    async loadFrameList() {
      this.frameListLoading = true;
      try {
        const res = await getFrameList({ interview_id: this.interviewId });
        const payload = res && res.data !== undefined ? res.data : res;
        const results = (payload && payload.results) || [];
        this.frameMeta = {
          total_frames: payload && payload.total_frames,
          normal_count: payload && payload.normal_count,
          abnormal_count: payload && payload.abnormal_count,
        };
        this.abnormalCount = Number(payload && payload.abnormal_count) || results.length;
        const baseTimeline = results.map((row) => ({
          id: row.id,
          t: row.frame_time_str || this.formatClock(row.frame_timestamp || 0),
          label: this.behaviorToLabel(row.behavior),
          desc: "",
          seek: Number(row.frame_timestamp) || 0,
          cos_key: row.cos_key || row.frame_url,
          behavior: row.behavior,
          type: "warn",
          thumbSignedUrl: "",
        }));
        // 不再一次性为全部帧请求签名 URL，避免海量并发导致卡顿；由虚拟列表可视区按需拉取
        this.timeline = baseTimeline;
        this.resetVirtualTimelineAfterListReplace();
      } catch (e) {
        this.timeline = [];
        this.abnormalCount = 0;
        this.resetVirtualTimelineAfterListReplace();
      } finally {
        this.frameListLoading = false;
      }
    },
    /**
     * 仅在接口返回并整体替换 timeline 后复位滚动与视口。
     * 勿用 watch(timeline)：滚动过程中对条目的 $set（缩略图签名等）也可能触发监听，导致滚条被拉回顶部。
     */
    resetVirtualTimelineAfterListReplace() {
      this.tlScrollTop = 0;
      const el = this.$refs.timelineBlockScroller;
      if (el) el.scrollTop = 0;
      this.$nextTick(() => {
        this.updateTlViewport();
        this.scheduleEnsureTimelineThumbs();
      });
    },
    async loadFrameReport() {
      this.frameReportLoading = true;
      try {
        const res = await getFrameReport({ interview_id: this.interviewId });
        const data = res && res.data ? res.data : res;
        this.aiDetectionSummary = data && data.ai_detection_summary ? data.ai_detection_summary : "";
        this.systemSuggestion = data && data.system_suggestion ? data.system_suggestion : "";
        this.riskLevel = data && data.risk_level != null ? String(data.risk_level) : "";
        this.riskScore = data && data.risk_score != null ? String(data.risk_score) : "";
      } catch (e) {
        this.aiDetectionSummary = "";
        this.systemSuggestion = "";
        this.riskLevel = "";
        this.riskScore = "";
      } finally {
        this.frameReportLoading = false;
      }
    },
    formatClock(sec) {
      const s = Math.max(0, Math.floor(Number(sec) || 0));
      const m = Math.floor(s / 60);
      const r = s % 60;
      const pad = (n) => String(n).padStart(2, "0");
      return `${pad(m)}:${pad(r)}`;
    },
    escapeHtml(str) {
      return String(str || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
    },
    /**
     * 把类似 **xxx** 的 markdown 加粗转换为 <strong>xxx</strong>
     */
    renderBoldMarkdownToHtml(raw) {
      const escaped = this.escapeHtml(raw);
      return escaped.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
    },
    onVideoLoaded() {
      // 同步当前视频倍速，避免切片播放时覆盖用户在原生控件里调整的速度
      this.onVideoRateChange();
      this.syncTimelineHeight();
    },
    onVideoRateChange() {
      const v = this.$refs.player;
      if (!v) return;
      this.playbackRate = v.playbackRate || 1;
    },
    onVideoError(e) {
      const err = e && e.target ? e.target.error : null;
      const code = err && typeof err.code === "number" ? err.code : "unknown";
      // 这里不强行停止播放，只提示原因便于定位：常见是 URL 过期/请求失败/格式不支持
      this.$message.error(`视频加载失败（code=${code}）。请检查 URL 是否过期、是否能被浏览器直接请求到 MP4。`);
      // 方便你打开 DevTools 后继续看更细的错误信息
      // eslint-disable-next-line no-console
      console.error("[InterviewReview] video error:", err);
    },
    syncTimelineHeight() {
      // 仅在双列布局时强制同步高度，移动端/窄屏下避免出现过高滚动容器
      try {
        const shouldSync = window.innerWidth > 980;
        if (!shouldSync) {
          this.timelineBlockHeight = null;
          return;
        }
        const el = this.$refs.videoShell;
        if (!el) return;
        const h = el.clientHeight;
        if (Number.isFinite(h) && h > 0) this.timelineBlockHeight = h;
      } catch (_) {
        // noop
      }
      this.$nextTick(() => this.updateTlViewport());
    },
    updateTlViewport() {
      const el = this.$refs.timelineBlockScroller;
      if (el && el.clientHeight > 0) this.tlViewportH = el.clientHeight;
    },
    onWindowResizeTl() {
      this.updateTlViewport();
      this.scheduleEnsureTimelineThumbs();
    },
    onTimelineScroll(e) {
      const t = e.target;
      if (!t) return;
      this.tlScrollTop = t.scrollTop;
      if (t.clientHeight > 0) this.tlViewportH = t.clientHeight;
      if (this._tlPointerDownOnScrollbar) this._tlDidScrollWhilePointerDown = true;
      if (this._tlScrollRaf) cancelAnimationFrame(this._tlScrollRaf);
      this._tlScrollRaf = requestAnimationFrame(() => {
        this._tlScrollRaf = null;
        this.scheduleEnsureTimelineThumbs();
      });
    },
    /** 仅当事件目标为滚动容器自身时触发（点在滚动条轨道/留白，不含列表行、按钮） */
    onTimelineScrollbarPointerDown() {
      if (this.frameListLoading || this.tlPanelThumbLoading) return;
      this._tlPointerDownOnScrollbar = true;
      this._tlDidScrollWhilePointerDown = false;
    },
    onTimelineGlobalPointerUp() {
      if (!this._tlPointerDownOnScrollbar) return;
      this._tlPointerDownOnScrollbar = false;
      const didScroll = this._tlDidScrollWhilePointerDown;
      this._tlDidScrollWhilePointerDown = false;
      if (!didScroll) return;
      if (this.frameListLoading) return;
      this.waitVisibleThumbsAfterScrollbarRelease();
    },
    /** 可视区内是否仍有需请求签名的缩略图（cos key，尚未 thumbSignedUrl） */
    visibleRangeNeedsThumbSigning() {
      const start = this.tlStartIndex;
      const end = this.tlEndIndex;
      for (let i = start; i < end; i++) {
        const it = this.timeline[i];
        if (!it || this.isMultiVoiceprintItem(it)) continue;
        const raw = String(it.cos_key || "").trim();
        if (!raw) continue;
        if (/^https?:\/\//i.test(raw)) continue;
        if (!it.thumbSignedUrl) return true;
      }
      return false;
    },
    /**
     * 拖动滚动条并松手后：补全签名并等待当前 DOM 内缩略图加载完毕；未完成前 v-loading 遮罩，避免继续拖动干扰。
     */
    async waitVisibleThumbsAfterScrollbarRelease() {
      if (this.frameListLoading || this._tlFinishingVisibleThumbs) return;
      this._tlFinishingVisibleThumbs = true;
      let blocked = false;
      const showMask = () => {
        if (!blocked) {
          blocked = true;
          this.tlPanelThumbLoading = true;
        }
      };
      try {
        if (this.visibleRangeNeedsThumbSigning()) showMask();
        await this.ensureTimelineThumbsForVisibleRange();
        await this.$nextTick();
        await this.$nextTick();
        const root = this.$refs.timelineBlockScroller;
        const imgs = root ? Array.from(root.querySelectorAll("img.tlThumb")) : [];
        if (imgs.some((img) => !img.complete)) showMask();
        if (blocked) await Promise.all(imgs.map(waitForImageEl));
      } finally {
        this.tlPanelThumbLoading = false;
        this._tlFinishingVisibleThumbs = false;
      }
    },
    scheduleEnsureTimelineThumbs() {
      if (this._tlThumbSignTimer) clearTimeout(this._tlThumbSignTimer);
      this._tlThumbSignTimer = setTimeout(() => {
        this._tlThumbSignTimer = null;
        this.ensureTimelineThumbsForVisibleRange();
      }, TL_THUMB_SIGN_DEBOUNCE_MS);
    },
    async ensureTimelineThumbsForVisibleRange() {
      const start = this.tlStartIndex;
      const end = this.tlEndIndex;
      const tasks = [];
      for (let i = start; i < end; i++) {
        const it = this.timeline[i];
        if (!it || this.isMultiVoiceprintItem(it)) continue;
        if (it.thumbSignedUrl) continue;
        const raw = String(it.cos_key || "").trim();
        if (!raw) continue;
        if (/^https?:\/\//i.test(raw)) {
          this.$set(it, "_thumbImgLoaded", false);
          this.$set(it, "_thumbSignEmpty", false);
          this.$set(it, "thumbSignedUrl", raw);
          continue;
        }
        if (it._thumbSigning) continue;
        tasks.push({ it, fileName: raw });
      }
      if (!tasks.length) return;
      const chunkSize = 6;
      for (let b = 0; b < tasks.length; b += chunkSize) {
        const chunk = tasks.slice(b, b + chunkSize);
        await Promise.all(
          chunk.map(async ({ it, fileName }) => {
            if (it.thumbSignedUrl || it._thumbSigning) return;
            this.$set(it, "_thumbSigning", true);
            try {
              const r = await getCommonFileLink({ fileName });
              const url = pickSignedUrl(r);
              if (url) {
                this.$set(it, "_thumbImgLoaded", false);
                this.$set(it, "_thumbSignEmpty", false);
                this.$set(it, "thumbSignedUrl", url);
              } else {
                this.$set(it, "thumbSignedUrl", "");
                this.$set(it, "_thumbImgLoaded", true);
                this.$set(it, "_thumbSignEmpty", true);
              }
            } catch (_) {
              this.$set(it, "thumbSignedUrl", "");
              this.$set(it, "_thumbImgLoaded", true);
              this.$set(it, "_thumbSignEmpty", true);
            } finally {
              this.$set(it, "_thumbSigning", false);
            }
          })
        );
      }
    },
    applyPlaybackRate() {
      const v = this.$refs.player;
      if (!v) return;
      const r = Number(this.playbackRate);
      v.playbackRate = Number.isFinite(r) && r > 0 ? r : 1;
    },
    onVideoTimeUpdate() {
      const v = this.$refs.player;
      if (!v || this.segmentEndTime == null) return;
      if (v.currentTime >= this.segmentEndTime - 0.04) {
        try {
          v.pause();
        } catch (_) {
          /* noop */
        }
        this.segmentEndTime = null;
        this.segmentStartTime = null;
      }
    },
    playSegment(item) {
      const v = this.$refs.player;
      if (!v) return;
      const anomalySec = Number(item && item.seek);
      const t0 = Number.isFinite(anomalySec) ? anomalySec : 0;
      const start = Math.max(0, t0 - this.segmentLeadSec);
      const dur = Math.max(1, Number(SEGMENT_DURATION_SEC) || 10);
      const end = start + dur;
      this.segmentStartTime = start;
      this.segmentEndTime = end;
      const run = () => {
        v.currentTime = start;
        // playbackRate 由原生控件 ratechange 同步维护，这里不额外“强行重置”
        const p = v.play();
        if (p && typeof p.catch === "function") p.catch(() => {});
      };
      if (v.readyState >= 1) run();
      else v.addEventListener("loadedmetadata", run, { once: true });
    },
    toggleFullscreen() {
      const v = this.$refs.player;
      const shell = this.$refs.videoShell;
      try {
        if (document.fullscreenElement || document.webkitFullscreenElement) {
          if (document.exitFullscreen) document.exitFullscreen();
          else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
          return;
        }
        if (v && typeof v.webkitEnterFullscreen === "function") {
          v.webkitEnterFullscreen();
          return;
        }
        if (shell && shell.requestFullscreen) shell.requestFullscreen();
        else if (shell && shell.webkitRequestFullscreen) shell.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      } catch (_) {
        this.$message.info("当前环境不支持全屏或需用户手势触发。");
      }
    },
    back() {
      if (window.history.length > 1) this.$router.back();
      else this.$router.push("/interviewer/dashboard");
    },
    download() {
      this.downloadVideo();
    },
    async downloadVideo() {
      this.fullscreenLoading = true;
      this.fullscreenLoadingText = "录像下载中...";
      try {
        // /common/download 建议也传对象 key（cos_url），否则只给 file_name 可能会取不到
        let fileName = String(this.videoCosUrl || this.videoFileName || "").trim();
        if (!fileName) fileName = extractFileNameFromUrl(this.videoSrc);

        if (!fileName) {
          this.$message.warning("无法获取录像文件名，下载失败");
          return;
        }

        const res = await commonGet("/common/download", { fileName, delete: false }, { responseType: "blob" });
        const blob = res && res.data instanceof Blob ? res.data : res && res.data ? new Blob([res.data]) : null;
        if (!blob) {
          this.$message.warning("下载失败：未获取到文件内容");
          return;
        }

        const objUrl = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = objUrl;
        const now = new Date();
        const timestamp = [
          now.getFullYear(),
          String(now.getMonth() + 1).padStart(2, "0"),
          String(now.getDate()).padStart(2, "0"),
          String(now.getHours()).padStart(2, "0"),
          String(now.getMinutes()).padStart(2, "0"),
          String(now.getSeconds()).padStart(2, "0"),
        ].join("");
        const candidateName = String(this.name || "候选人").replace(/[\\/:*?"<>|]/g, "_").trim() || "候选人";
        a.download = `${candidateName}面试录像回放${timestamp}.mp4`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(objUrl);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("downloadVideo failed:", e);
        // this.$message.warning("下载失败");
      } finally {
        this.fullscreenLoading = false;
      }
    },
    async submit() {
      if (this.isViewMode) return;
      if (this.submittingRemarks) return;
      const conclusion = Number(this.decision);
      if (![1, 2, 3].includes(conclusion)) {
        this.$message.warning("请选择复核结论");
        return;
      }
      const remarks = String(this.remark || "").trim();
      if (remarks.length > 300) {
        this.$message.warning("备注最多 300 字");
        return;
      }

      this.submittingRemarks = true;
      try {
        await submitRecordingRemarks({
          interview_id: this.interviewId,
          review_conclusion: conclusion,
          review_remarks: remarks,
        });
        this.$message.success("复核结果已提交");
        await this.$router.push({ name: "interviewer-dashboard-review" }).catch(() => {});
      } catch (e) {
        // this.$message.error("复核结果提交失败");
      } finally {
        this.submittingRemarks = false;
      }
    },
  },
};
</script>

<style scoped>
.page {
  min-height: 100%;
  padding: 18px 16px 22px;
}
.wrap {
  max-width: 1160px;
  margin: 0 auto;
}
.top {
  border: 1px solid #e5e7eb;
  background: rgba(255, 255, 255, 0.85);
  color: #111827;
}
.title {
  font-size: 16px;
  font-weight: 900;
}
.title-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.sub {
  margin-top: 6px;
  font-size: 12px;
  color: #6b7280;
}
.meta {
  margin-top: 6px;
  font-size: 12px;
  color: #6b7280;
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
.right {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 10px;
}
.back-icon {
  width: 18px;
  height: 18px;
  min-width: 18px;
  fill: #334155;
  cursor: pointer;
}
.back-icon:hover,
.back-icon:focus {
  fill: #2563eb;
}
.back-icon:focus {
  outline: none;
}
.back-icon:focus-visible {
  outline: 2px solid rgba(37, 99, 235, 0.35);
  outline-offset: 2px;
  border-radius: 4px;
}
.grid {
  display: grid;
  grid-template-columns: minmax(0, 1.45fr) minmax(0, 1.1fr);
  gap: 12px;
  align-items: stretch;
}
@media (max-width: 980px) {
  .grid {
    grid-template-columns: 1fr;
  }
}
.card {
  border: 1px solid #e5e7eb;
  background: rgba(255, 255, 255, 0.9);
  color: #111827;
}
.cardH {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
  border-bottom: none;
  background: #ffffff;
}
.timelineCard {
  display: flex;
  flex-direction: column;
}
.timelineCard ::v-deep .el-card__body {
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}
.timelineCard .twoCol {
  flex-shrink: 0;
}
.videoWrap {
  border-radius: 14px;
  border: 1px solid #e5e7eb;
  background: #000;
  aspect-ratio: 16/9;
  overflow: hidden;
  position: relative;
}
.videoEl {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  z-index: 1;
}
.videoToolbar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 5;
  padding: 6px 8px 10px;
  background: linear-gradient(180deg, rgba(17, 24, 39, 0.72), rgba(17, 24, 39, 0));
  pointer-events: none;
}
.toolbarRow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}
.toolbarLabel {
  font-size: 11px;
  color: #f3f4f6;
  white-space: nowrap;
}
.toolbarUnit {
  font-size: 11px;
  color: #e5e7eb;
}
.toolbarGap {
  width: 6px;
}
.rateSelect {
  width: 92px;
}
/* 使用 video 原生 controls：不隐藏三点/溢出菜单 */
.segmentHint {
  margin-top: 4px;
  font-size: 11px;
  color: #fde68a;
  line-height: 1.4;
}
.videoUnderHint {
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-direction: column;
  align-items: flex-start;
}
.videoUnderHint .overlayHint {
  margin-top: 0;
}
.overlayHint {
  font-size: 14px;
  color: #6b7280;
}
.riskMeta {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.metrics {
  margin-top: 10px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.twoCol {
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 10px;
}
@media (max-width: 880px) {
  .twoCol {
    grid-template-columns: 1fr;
  }
}
/* 每个检测意见文字区域单独 loading，需占位高度 */
.boxTextWrap {
  position: relative;
  min-height: 80px;
}
/* 检测意见两块区域较小，loading 转圈缩小（不影响下方异常时间轴） */
.boxTextWrap.loading-gray ::v-deep .el-loading-spinner {
  transform: scale(0.62);
  transform-origin: center center;
}
.box {
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  padding: 10px 10px;
  font-size: 12px;
  color: #4b5563;
  line-height: 1.6;
}
.boxText {
  max-height: 80px;
  overflow-y: auto;
}
.boxText::-webkit-scrollbar {
  width: 4px;
}
.boxText::-webkit-scrollbar-track {
  background: transparent;
}
.boxText::-webkit-scrollbar-thumb {
  background-color: rgba(156, 163, 175, 0.8);
  border-radius: 999px;
}
.boxTitle {
  font-size: 12px;
  font-weight: 900;
  color: #111827;
  margin-bottom: 6px;
}
.timelineSection {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}
.tlTitle {
  flex-shrink: 0;
  margin-top: 0;
  padding: 12px 0 8px;
  background: rgba(255, 255, 255, 0.97);
  font-size: 12px;
  font-weight: 900;
}
.timelineBlockScroller {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding-right: 6px; /* 给滚动条留点空间，避免遮挡内容 */
  box-sizing: border-box;
}
.virtualTlWindow {
  display: flex;
  flex-direction: column;
  gap: 0;
}
.virtualTlRowSlot {
  flex-shrink: 0;
  box-sizing: border-box;
}
.tlItem {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  flex-shrink: 0;
  overflow: hidden;
}
.tlLeft {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  min-width: 0;
}
.tlThumbSlot {
  position: relative;
  width: 52px;
  height: 40px;
  flex-shrink: 0;
  background: #f3f4f6;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  box-sizing: border-box;
}
.tlThumbPh {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f3f4f6;
  border-radius: 6px;
  box-sizing: border-box;
}
.tlThumbPhIcon {
  font-size: 18px;
  color: #9ca3af;
}
.tlThumb {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px;
  box-sizing: border-box;
  flex-shrink: 0;
  background: #f3f4f6;
  opacity: 0;
  transition: opacity 0.2s ease;
}
.tlThumbVisible {
  opacity: 1;
}
.tlText {
  min-width: 0;
}
.tlEmpty {
  font-size: 12px;
  color: #9ca3af;
  padding: 8px 4px;
}
.tlK {
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tlD {
  margin-top: 2px;
  font-size: 11px;
  color: #6b7280;
  line-height: 1.45;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.btnRow {
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
}
.hint {
  font-size: 12px;
  color: #6b7280;
}

/* Element UI loading：转圈改为灰色（检测意见两处 + 异常时间轴） */
.loading-gray ::v-deep .el-loading-spinner .path {
  stroke: #909399 !important;
}
.loading-gray ::v-deep .el-loading-spinner i {
  color: #909399 !important;
}

::v-deep .el-card__header {
  padding-top: 5px;
  padding-bottom: 5px;
}
</style>

